// Holds the currently-selected environment slug so the API client can attach
// the X-Deleggate-Env header without importing the Zustand store (which would
// create an import cycle: client → store → api types → client). The env store
// keeps this in sync via setActiveEnvSlug.
let activeEnvSlug: string | null = null;

export function setActiveEnvSlug(slug: string | null) {
  activeEnvSlug = slug;
}

export function getActiveEnvSlug(): string | null {
  return activeEnvSlug;
}
